module.exports = __webpack_public_path__ + "img/JalaPro.4fba60e3.svg";